/**
 * Consent capture client — wraps the consent actions on /api/account. Used by ConsentGate (signup /
 * first-login block) and any future account-settings marketing-prefs toggle.
 */
import { apiFetch } from './api-client';

export type LegalDocumentType = 'privacy' | 'terms' | 'merchant';

export interface ConsentStatus {
  accepted: Record<LegalDocumentType, { version: string; acceptedAt: string } | null>;
  marketingEmailOptIn: boolean;
  marketingPushOptIn: boolean;
  marketingPrefsUpdatedAt: string | null;
}

export async function getConsentStatus(): Promise<ConsentStatus> {
  return apiFetch<ConsentStatus>('/api/account', { action: 'consent-status' });
}

export async function recordConsent(documentType: LegalDocumentType, documentVersion: string): Promise<void> {
  await apiFetch<void>('/api/account', { action: 'consent-record', documentType, documentVersion });
}

export async function updateMarketingPrefs(prefs: {
  marketingEmailOptIn?: boolean;
  marketingPushOptIn?: boolean;
}): Promise<void> {
  await apiFetch<void>('/api/account', { action: 'consent-marketing-prefs', ...prefs });
}
